import { render, staticRenderFns } from "./saleInvoiceTrash.vue?vue&type=template&id=fc743ae0&scoped=true&"
import script from "./saleInvoiceTrash.vue?vue&type=script&lang=js&"
export * from "./saleInvoiceTrash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc743ae0",
  null
  
)

export default component.exports